import { configureStore } from '@reduxjs/toolkit'

import Category from './mapPage/category'
import Event from './mapPage/event'
import Route from './mapPage/route'
import Search from './mapPage/search'

export const store = configureStore({
  reducer: {
    Categories: Category,
    Events: Event,
    Routes: Route,
    Searches: Search
  },
})

export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch